import { BreakpointObserver } from '@angular/cdk/layout';
import { AsyncPipe, CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  MatDrawerMode,
  MatSidenav,
  MatSidenavModule,
} from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import {
  QarepaBaseSubsDirective,
  QarepaProgressBarService,
} from '@qarepa/common';
import { ImagesConfig } from '@qaroni-core/conf/images/images.config';
import { map, shareReplay } from 'rxjs';
import { LayoutValuesListComponent } from '../layout-values-list/layout-values-list.component';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'qaroni-panel-layout',
  standalone: true,
  imports: [
    CommonModule,
    LayoutValuesListComponent,
    MatIconModule,
    MatProgressBarModule,
    MatSidenavModule,
    MenuComponent,
    RouterOutlet,
  ],
  providers: [AsyncPipe],
  templateUrl: './panel-layout.component.html',
  styleUrl: './panel-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelLayoutComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  @ViewChild('drawer') drawer!: MatSidenav;

  public ImagesConfig = ImagesConfig;
  public isSidenav = true;
  public openSidenav = true;
  public hasBackdrop = false;
  public matDrawermode: MatDrawerMode = 'side';

  private asyncPipe = inject(AsyncPipe);
  private breakpointObserver = inject(BreakpointObserver);
  private progressBarService = inject(QarepaProgressBarService);

  public progressBar$ = this.progressBarService.getProgressBar$();
  public isSmallScreen$ = this.breakpointObserver
    .observe('(max-width: 1024px)')
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  ngOnInit(): void {
    this.subs.add(this.isSmallScreen$.subscribe(this.nextIsSmallScreen));
  }

  private nextIsSmallScreen = (result: boolean): void => {
    if (!result) {
      this.hasBackdrop = false;
      this.openSidenav = true;
      this.matDrawermode = 'side';
      return;
    }

    this.hasBackdrop = true;
    this.openSidenav = false;
    this.matDrawermode = 'over';
  };

  public toggle(): void {
    this.isSidenav = !this.isSidenav;
  }

  protected setToggle(): void {
    if (!this.isSidenav) {
      this.isSidenav = !this.isSidenav;
    }
  }

  public openMenu(): void {
    this.openSidenav = !this.openSidenav;
  }

  public close(): void {
    if (!this.asyncPipe.transform(this.isSmallScreen$)) {
      return;
    }

    this.drawer.close();
  }
}
